import makeLookupModal from "../../UI/LookupModal/LookupModal";
import AdmitStatusLookup from "./AdmitStatusLookup";
const AdmitStatusLookupModal = makeLookupModal(AdmitStatusLookup, {
    pluralEntityName: "Admit Statuses",
});
export default AdmitStatusLookupModal;
